import { createContext } from 'react';

import { NofomoStoreReturnType } from './zustand';

export const NofomoStoreContext = createContext<NofomoStoreReturnType | null>(
  null,
);
